import { Map } from "immutable";
import { notification } from "antd";
import { store } from "../redux/store";
import authActions from "../redux/auth/actions";

export function clearToken() {
  localStorage.removeItem("id_token");
}

export function getToken() {
  try {
    const idToken = localStorage.getItem("id_token");
    return new Map({ idToken });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

// Custom hook for logout functionality
const { logout } = authActions;

export async function fetchAndReturn(url, parameters) {
  try {
    const response = await fetch(url, parameters);
    const [statusCode, data] = [response.status, await response.json()];

    if (statusCode === 409) {
      store.dispatch(logout());
      localStorage.clear();
      window.location.href = "/signin";
    }

    return [statusCode, data];
  } catch (error) {
    throw error;
  }
}

export const uploadImage = (e, setter) => {
  const selectedFile = e.file;
  const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
  const filesize = Number((selectedFile.size / 1024 / 1024).toFixed(4)); // MB

  if (!allowedTypes.includes(selectedFile?.type)) {
    notification["error"]({
      message:
        "Можете да качите само файлове, който са тип .jpg .jpeg .png .webp",
    });
    return;
  }
  if (filesize > 20) {
    notification["error"]({
      message: "Големината на снимката трябва да е под 20мб",
    });
    return;
  }

  const data = new FileReader();
  data.addEventListener("load", () => {
    setter(data.result);
  });
  data.readAsDataURL(selectedFile);
};

export const capitalizeTitleCase = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

// move element in array by index from old index to new index
export function arrayMoveElementsByIndex(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
}
